export const NARROW_CONTAINER_WIDTH = '250px';
export const WIDE_CONTAINER_WIDTH = '500px';
